export default __webpack_public_path__ + "static/media/big_sky_1.cdbb3f27.jpg";